/**
 * @generated SignedSource<<14f98f373058208bde78b4156c6934cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GuildMembershipLevel = "EDITOR" | "MEMBER" | "ORGANIZER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type GuildBentoScreenMember_guildMembership$data = {
  readonly id: string;
  readonly membershipLevel: GuildMembershipLevel;
  readonly user: {
    readonly recentPresentations: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly title: string;
        };
      }>;
      readonly totalCount: number;
    };
    readonly totalEventAttendance: {
      readonly totalCount: number;
    };
    readonly " $fragmentSpreads": FragmentRefs<"UserCardNew_user">;
  } | null | undefined;
  readonly " $fragmentType": "GuildBentoScreenMember_guildMembership";
};
export type GuildBentoScreenMember_guildMembership$key = {
  readonly " $data"?: GuildBentoScreenMember_guildMembership$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildBentoScreenMember_guildMembership">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildBentoScreenMember_guildMembership",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "membershipLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserCardNew_user"
        },
        {
          "alias": "recentPresentations",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 3
            },
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "CREATED_AT_DESC"
              ]
            }
          ],
          "concreteType": "PresentationsConnection",
          "kind": "LinkedField",
          "name": "presentationsByPresenterId",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "PresentationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Presentation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "presentationsByPresenterId(first:3,orderBy:[\"CREATED_AT_DESC\"])"
        },
        {
          "alias": "totalEventAttendance",
          "args": null,
          "concreteType": "EventsConnection",
          "kind": "LinkedField",
          "name": "eventAttendance",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GuildMembership",
  "abstractKey": null
};
})();

(node as any).hash = "6fc49c5c26dc762b4d265d8b50193d12";

export default node;
